import React, {createContext} from 'react';
import './App.css';
import 'bootstrap-icons/font/bootstrap-icons.css'
import {BrowserRouter, NavLink, Outlet, Route, Routes, useParams} from "react-router-dom";
import Home from "./pages/Home";
import NuotoCorsi from "./pages/Nuoto_pages/NuotoCorsi";
import Nuoto from "./pages/Nuoto_pages/Nuoto";
import NuotoLibero from "./pages/Nuoto_pages/NuotoLibero";
import LezioniIndividuali from "./pages/Nuoto_pages/LezioniIndividuali";
import AcquaFitness from "./pages/Nuoto_pages/AcquaFitness";
import RiabilitazioneMotoria from "./pages/Nuoto_pages/RiabilitazioneMotoria";
import Palestra from "./pages/Palestra";
import Fitness from "./pages/Fitness";
import Runnering from "./pages/Runnering";
import Danza from "./pages/Danza";
import Spa from "./pages/Spa";
import Multitessere from "./pages/Multitessere";
import News from "./pages/News";
import ChiSiamo from "./pages/ChiSiamo";
import Contatti from "./pages/Contatti";
import Calendario from "./pages/Calendario";
import Regolamento from "./pages/Regolamento";
import Osteopata from "./pages/Osteopata";
import VisiteMediche from "./pages/VisiteMediche";
import Abbigliamento from "./pages/Abbigliamento";
import Cafe from "./pages/Cafe";
import Footer from "./pages/Footer";
import "./globalStyles.css"
import SireneNews from "./pages/news_pages/SireneNews";
import NewsHome from "./pages/NewsHome";
import ZumbaNews from "./pages/news_pages/ZumbaNews";
import BlackFridayNews from "./pages/news_pages/BlackFridayNews";
import ScrollToTopOnMount from "./components/ScrollToTopOnMount";
import Master from "./pages/Nuoto_pages/Master";
import SanValentinoNews from "./pages/news_pages/SanValentinoNews";
import { Helmet } from 'react-helmet';
import CarnevaleNews from "./pages/news_pages/CarnevaleNews";
import Bar_2 from "./components/Bar_2";
import Bar_gestione from "./components/Bar_gestione";
import EventoFitnessNews from "./pages/news_pages/EventoFitnessNews";
import PromoMarzoNews from "./pages/news_pages/PromoMarzoNews";
import RegolamentoPiscina from "./pages/Nuoto_pages/RegolamentoPiscina";
import BaristaNews from "./pages/news_pages/BaristaNews";
import PromoFineNews from "./pages/news_pages/PromoFineNews";
import CorsiEstivi from "./pages/CorsiEstivi";
import estiviimg from "../src/images/Estivi/Estivi_card.jpg"
import GarePreAgo from "./pages/Nuoto_pages/GarePreAgo";
import PreIs_bambini from "./pages/news_pages/PreIs_bambini";
import PreIs_adulti from "./pages/news_pages/PreIs_adulti";
import NuoviCorsi from "./pages/news_pages/NuoviCorsi";
import Armadietti from "./pages/news_pages/Armadietti";
import InizioCorsi from "./pages/news_pages/InizioCorsi";
import NotFound from "./pages/NotFound";
import Prova from "./components/home/Prova";
import OrarioNatalizio from "./pages/news_pages/OrarioNatalizio";
import Manutenzione from "./pages/news_pages/Manutenzione";
import CorsoBls from "./pages/news_pages/CorsoBls";
import PromoPrimaveraNews from "./pages/news_pages/PromoPrimavera";
import Pasqua2025 from "./pages/news_pages/Pasqua2025";
import PromoAnnuali from "./pages/news_pages/PromoAnnuali";
import Preiscrizioni_Nuoto from "./pages/news_pages/Preiscrizioni_Nuoto";
import SquadraAvviso from "./pages/news_pages/SquadraAvviso";
import Ballo from "./pages/Ballo";
import Facilitazione from "./pages/news_pages/Facilitazione";
import SurfNews from "./pages/news_pages/SurfNews";
import PtNews from "./pages/news_pages/PtNews";
import BlackFriday from "./pages/news_pages/BlackFriday";
import Safeguarding from "./pages/Safeguarding/Safeguarding";
import Brema from "./pages/news_pages/Brema";
import PromoPrimavera26 from "./pages/news_pages/PromoPrimavera26";
import Pasqua2026 from "./pages/news_pages/Pasqua2026";
import GareSociali26 from "./pages/news_pages/GareSociali26";
import CampEstivo from "./pages/CampEstivo";
import PromoPalestraNews from "./pages/news_pages/PromoPalestra";
import SwimSubscriptionCalculator from "./pages/CalcoloAbbonamento";
import PreIscrizioni from "./pages/news_pages/PreIscrizioni";
import CampEstivoSettembre from "./pages/CampEstivoSettembre";
import Chiusura2026 from "./pages/news_pages/Chiusura2026";
import InizioStagione2627 from "./pages/news_pages/InizioStagione2627";



function Main() {

    return(
        <div>
            <Bar_gestione />
            <div style={{height: "90px", width: "100%"}}></div>
            <Outlet />
            <div style={{width: "100%", backgroundColor: "#032041"}}>
                <PageFooter />
            </div>
        </div>
    )
}

// <Footer /> dopo Outlet

function PageHome() {
    return (
        <div>
            <Helmet>
                <title>Centro Sportivo Il Cigno</title>
                <meta name="description" content="Piscina, Palestra, Danza, Fitness, Runnering, SPA" />
            </Helmet>
            <Home/>
        </div>
    );
}

function PageNuoto() {
    return(
        <div>
            <Helmet>
                <title>Piscina</title>
                <meta name="description" content="Scopri tutti i nostri corsi di nuoto e acquafitness" />
            </Helmet>
            <Nuoto />
        </div>
    )
}
function PageNuotolibero() {
    return(
        <div>
            <Helmet>
                <title>Nuoto Libero</title>
                <meta name="description" content="Corsie vasca grande sempre disponibili" />
            </Helmet>
            <NuotoLibero />
        </div>
    )
}
function PageCorsinuoto() {
    return(
        <div>
            <Helmet>
                <title>Corsi Nuoto</title>
                <meta name="description" content="Scuola federale FIN" />
            </Helmet>
            <NuotoCorsi />
        </div>
    )
}
function PageLezionindividuali() {
    return(
        <div>
            <Helmet>
                <title>Lezioni Individuali</title>
                <meta name="description" content="Lezioni da 45 minuti con un istruttore dedicato a te e alle tue esigenze" />
            </Helmet>
            <LezioniIndividuali />
        </div>
    )
}
function PageAcquafitness() {
    return(
        <div>
            <Helmet>
                <title>Acqua Fitness</title>
                <meta name="description" content="Attività aerobica in acqua di intensità medio/alta a ritmo di musica" />
            </Helmet>
            <AcquaFitness />
        </div>
    )
}
function PageRiabilitazionemotoria() {
    return(
        <div>
            <Helmet>
                <title>Riabilitazione Motoria</title>
                <meta name="description" content="Rivolgiti in palestra e chiedi di Antonio o Simone. 3315824140 / 3501516715" />
            </Helmet>
            <RiabilitazioneMotoria />
        </div>
    )
}

function PageMaster() {
    return(
        <div>
            <Helmet>
                <title>Master</title>
                <meta name="description" content="Squadra Master del Cigno" />
            </Helmet>
            <Master />
        </div>
    )
}

function PagePalestra() {
    return(
        <div>
            <Helmet>
                <title>Palestra</title>
                <meta name="description" content="Accesso libero ai due ambienti: sala cardio e sala pesi. Scheda personalizzata per tutti gli iscritti" />
            </Helmet>
            <Palestra />
        </div>
    )
}

function PageFitness() {
    return(
        <div>
            <Helmet>
                <title>Fitness</title>
                <meta name="description" content="Scopri tutti i nostri corsi fitness" />
            </Helmet>
            <Fitness />
        </div>
    )
}

function PageDanza() {
    return(
        <div>
            <Helmet>
                <title>Danza</title>
                <meta name="description" content="Scuola danza Il Cigno" />
            </Helmet>
            <Danza />
        </div>
    )
}

function PageSpa() {
    return(
        <div>
            <Helmet>
                <title>SPA</title>
                <meta name="description" content="Reparto termale" />
            </Helmet>
            <Spa />
        </div>
    )
}

function PageRunnering() {
    return(
        <div>
            <Helmet>
                <title>Runnering</title>
                <meta name="description" content="Allenamento e divertimento di gruppo su tapis roulant" />
            </Helmet>
            <Runnering />
        </div>
    )
}

function PageMultitessere() {
    return(
        <div>
            <Helmet>
                <title>Multitessere</title>
                <meta name="description" content="Scopri la formula di abbonamento più adatta a te" />
            </Helmet>
            <Multitessere />
        </div>
    )
}

function PageNews() {
    return(
        <div>
            <Helmet>
                <title>News</title>
                <meta name="description" content="Resta sempre aggiornato su eventi e promo" />
            </Helmet>
            <News />
            <Outlet />
        </div>
    )
}

function PageChiSiamo() {
    return(
        <div>
            <Helmet>
                <title>Chi Siamo</title>
                <meta name="description" content="Scopri il centro" />
            </Helmet>
            <ChiSiamo />
        </div>
    )
}

function PageContatti() {
    return(
        <div>
            <Helmet>
                <title>Contatti</title>
                <meta name="description" content="Via Fiorani, 74 20099 Sesto San Giovanni (MI) tel. 02 2401 006" />
            </Helmet>
            <Contatti />
        </div>
    )
}

function PageCalendario() {
    return(
        <div>
            <Helmet>
                <title>Calendario</title>
                <meta name="description" content="Info su chiusure e cambio orari d'apertura" />
            </Helmet>
            <Calendario />
        </div>
    )
}

function PageRegolamento() {
    return(
        <div>
            <Helmet>
                <title>Regolamento</title>
                <meta name="description" content="Regolamento centro sportivo" />
            </Helmet>
            <Regolamento />
        </div>
    )
}
function PageSafeguarding() {
    return(
        <div>
            <Helmet>
                <title>Safeguarding</title>
                <meta name="description" content="Safeguarding" />
            </Helmet>
            <Safeguarding />
        </div>
    )
}

function PageOsteopata() {
    return(
        <div>
            <Helmet>
                <title>Osteopata</title>
                <meta name="description" content="Studio di osteopatia. Andrea Pannunzio" />
            </Helmet>
            <Osteopata />
        </div>
    )
}

function PageVisitemediche() {
    return(
        <div>
            <Helmet>
                <title>Visite mediche</title>
                <meta name="description" content="Visite mediche in struttura. Per appuntamenti 022426191" />
            </Helmet>
            <VisiteMediche />
        </div>
    )
}

function PageAbbigliamento() {
    return(
        <div>
            <Helmet>
                <title>Abbigliamento</title>
                <meta name="description" content="Esplora il nostro stile sportivo. Acquista direttamente presso il nostro centro" />
            </Helmet>
            <Abbigliamento />
        </div>
    )
}
function PageBallo() {
    return(
        <div>
            <Helmet>
                <title>Ballo</title>
                <meta name="description" content="Salsa y Bachata" />
            </Helmet>
            <Ballo />
        </div>
    )
}

function PageCafe() {
    return(
        <div>
            <Helmet>
                <title>Il Cigno Cafè</title>
                <meta name="description" content="Dal lunedì al venerdì	9-19.30 - sabato 9-15 - domenica 9-12.30" />
            </Helmet>
            <Cafe />
        </div>
    )
}
function PageCamp() {
    return(
        <div>
            <Helmet>
                <title>Summer Camp Sesto San Giovanni | Il Cigno </title>

                <meta
                    name="description"
                    content="Summer Camp a Sesto San Giovanni per bambini 5-11 anni. Dal 8 giugno al 24 luglio con piscina, sport, giochi e corso di nuoto giornaliero."
                />

                <meta name="keywords" content="summer camp sesto san giovanni, centro estivo bambini milano, camp estivo piscina, il cigno sport camp" />

                <link rel="canonical" href="https://www.ilcignosport.it/news/summerCamp2026" />
            </Helmet>
            <CampEstivoSettembre />
        </div>
    )
}

function PageFooter() {
    return (
        <Footer />
    );
}

function PageNewsHome() {
    return(
        <div>
            <NewsHome />
        </div>
    )
}
function PageCorsiEstivi() {
    return(
        <div>
            <Helmet>
                <title>Corsi Estivi</title>
                <meta name="description" content="Corsi estivi dal 17 giugno al 26 luglio" />
                <meta property="og:url"                content="https://www.ilcignosport.it/corsiestivi" />
                <meta property="og:type"               content="article" />
                <meta property="og:title"              content="Corsi estivi 2024" />
                <meta property="og:description"        content="Dal 17 giugno al 26 luglio" />
                <meta property="og:image"              content={estiviimg} />
            </Helmet>
            <CorsiEstivi />
        </div>
    )
}





function App() {

    return (
        <div>
            <BrowserRouter>
                <Routes>
                    <Route path="*" element={<NotFound />} />

                    <Route path="/" element={<Main/>}>
                        <Route path={"/"} element={<PageHome/>}></Route>
                        <Route path={"/prova"} element={<Prova/>}></Route>
                        <Route path={"/chisiamo"} element={<PageChiSiamo/>}></Route>
                        <Route path={"/contatti"} element={<PageContatti/>}></Route>
                        <Route path={"/calendario"} element={<PageCalendario/>}></Route>
                        <Route path={"/regolamento"} element={<PageRegolamento/>}></Route>
                        <Route path={"/safeguarding"} element={<PageSafeguarding/>}></Route>
                        {/*
                        <Route path={"/osteopata"} element={<PageOsteopata/>}></Route>
                        */}
                        <Route path={"/visitemediche"} element={<PageVisitemediche/>}></Route>
                        <Route path={"/abbigliamento"} element={<PageAbbigliamento/>}></Route>
                        <Route path={"/piscina"} element={<PageNuoto/>}></Route>
                        <Route path={"/nuotolibero"} element={<PageNuotolibero/>}></Route>
                        <Route path={"/corsinuoto"} element={<PageCorsinuoto/>}></Route>
                        <Route path={"/lezionindividuali"} element={<PageLezionindividuali/>}></Route>
                        <Route path={"/acquafitness"} element={<PageAcquafitness/>}></Route>
                        <Route path={"/riabilitazionemotoria"} element={<PageRiabilitazionemotoria/>}></Route>
                        <Route path={"/master"} element={<PageMaster/>}></Route>
                        <Route path={"/palestra"} element={<PagePalestra/>}></Route>
                        <Route path={"/fitness"} element={<PageFitness/>}></Route>
                        <Route path={"/danza"} element={<PageDanza/>}></Route>
                        <Route path={"/spa"} element={<PageSpa/>}></Route>
                        <Route path={"/runnering"} element={<PageRunnering/>}></Route>
                        <Route path={"/multitessere"} element={<PageMultitessere/>}></Route>
                        <Route path={"/ballo"} element={<PageBallo/>}></Route>
                        {/*
                        <Route path={"/calcoloFineTessera"} element={<SwimSubscriptionCalculator/>}></Route>
                        */}
                        <Route path="/news" element={<PageNews/>}>
                            <Route path={"/news"} element={<PageNewsHome/>}></Route>
                            <Route path={"/news/sirene"} element={<SireneNews/>}></Route>
                            <Route path={"/news/zumba"} element={<ZumbaNews/>}></Route>
                            <Route path={"/news/blackFriday"} element={<BlackFridayNews/>}></Route>
                            <Route path={"/news/sanvalentino"} element={<SanValentinoNews/>}></Route>
                            <Route path={"/news/festacarnevale"} element={<CarnevaleNews/>}></Route>
                            <Route path={"/news/eventofitness"} element={<EventoFitnessNews/>}></Route>
                            <Route path={"/news/promomarzo"} element={<PromoMarzoNews/>}></Route>
                            <Route path={"/news/barista"} element={<BaristaNews/>}></Route>
                            <Route path={"/news/promofinestagione"} element={<PromoFineNews/>}></Route>
                            <Route path={"/news/preiscrizionibambini"} element={<PreIs_bambini/>}></Route>
                            <Route path={"/news/preiscrizioniadulti"} element={<PreIs_adulti/>}></Route>
                            <Route path={"/news/novità2024"} element={<NuoviCorsi/>}></Route>
                            <Route path={"/news/armadietti"} element={<Armadietti/>}></Route>
                            <Route path={"/news/inizioCorsi"} element={<InizioCorsi/>}></Route>
                            <Route path={"/news/orario_natalizio"} element={<OrarioNatalizio/>}></Route>
                            <Route path={"/news/manutenzione"} element={<Manutenzione/>}></Route>
                            <Route path={"/news/corsoBls"} element={<CorsoBls/>}></Route>
                            <Route path={"/news/promoPrimavera2025"} element={<PromoPrimaveraNews/>}></Route>
                            <Route path={"/news/pasqua2025"} element={<Pasqua2025/>}></Route>
                            <Route path={"/news/promoAnnuali"} element={<PromoAnnuali/>}></Route>
                            <Route path={"/news/preiscrizioniScuolaNuoto"} element={<Preiscrizioni_Nuoto/>}></Route>
                            <Route path={"/news/squadraAgonistica"} element={<SquadraAvviso/>}></Route>
                            <Route path={"/news/chiusura"} element={<Chiusura2026/>}></Route>
                            <Route path={"/news/facilitazione"} element={<Facilitazione/>}></Route>
                            <Route path={"/news/surf"} element={<SurfNews/>}></Route>
                            <Route path={"/news/personaltraining"} element={<PtNews/>}></Route>
                            <Route path={"/news/blackFriday2025"} element={<BlackFriday/>}></Route>
                            <Route path={"/news/brema"} element={<Brema/>}></Route>
                            <Route path={"/news/Primavera26"} element={<PromoPrimavera26/>}></Route>
                            <Route path={"/news/Pasqua26"} element={<Pasqua2026/>}></Route>
                            <Route path={"/news/gareSociali2026"} element={<GareSociali26/>}></Route>
                            <Route path={"/news/promoPalestra"} element={<PromoPalestraNews/>}></Route>
                            <Route path={"/news/preiscrizioni26-27"} element={<PreIscrizioni/>}></Route>
                            <Route path={"/news/inizioStagione2627"} element={<InizioStagione2627/>}></Route>
                        </Route>
                        <Route path="/regolamentopiscina" element={<RegolamentoPiscina />}></Route>
                        <Route path={"/corsinuoto/garepreagonistica"} element={<GarePreAgo />}></Route>
                        <Route path={"/corsiEstivi2026"} element={<CorsiEstivi />} ></Route>
                        <Route path={"/news/summerCamp2026"} element={<PageCamp />}></Route>
                    </Route>
                </Routes>
            </BrowserRouter>
        </div>
    );
}
export default App;
